import { Observable } from "rxjs";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { RecordsManager } from "../../modules/records/records-manager";

export class CreateCommand<
  T extends object,
  S extends IApiService<T> & {
    create: (el: T) => Observable<any>;
    hasMarket: boolean;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  label = "create";
  layout: "flat" | "raised" | "normal" = "raised";
  constructor(public service: S) {}
  execute(el: T) {
    this.service.create(el).subscribe((res) => {
      res && this.receiver.onSuccess();
    });
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    return this.receiver.isLoading || !this.service.hasMarket;
  }
}
